import { parseCookies } from 'nookies'
import { TOKEN_COOKIE } from '@/constants/session'

const currentSessionToken = (): string | undefined => parseCookies()[TOKEN_COOKIE] || undefined

/**
 * Guarda da resposta em voo: devolve o `handler` preso à sessão (cookie do token) do momento em que foi criado, ou
 * seja, da chamada. Se um logout ou outro login aconteceu enquanto a chamada estava no ar, a resposta é do cliente
 * anterior e o handler não roda (não grava na store dado de quem já saiu).
 *
 * Uso: `.onSuccess(whileSameSession(storeCart))` nos services que gravam dado do cliente (carrinho, checkout, cupom,
 * cliente, endereços). Os logins não usam: são eles que trocam a sessão.
 */
export function whileSameSession<T>(handler: (data: T) => void | Promise<void>): (data: T) => void | Promise<void> {
    const tokenAtCall = currentSessionToken()
    return (data) => {
        if (currentSessionToken() !== tokenAtCall) return
        return handler(data)
    }
}
